import type { RuleEdgeProps } from "../types/edges";
import BaseEdge from "./BaseEdge";

const DefaultEdge = (props: RuleEdgeProps) => {
	return (
		<BaseEdge
			{...props}
			data={{
				...props.data,
				color: props.data?.color ?? "#DBDCDE",
			}}
		/>
	);
};

export default DefaultEdge;
